export const GET_PERSONAL_AGENT_LINK = 'profile-get-personal-agent-link';
export const CREATE_PERSONAL_AGENT_LINK = 'profile-create-personal-agent-link';
export const UPDATE_PERSONAL_AGENT_LINK = 'profile-update-personal-agent-link';
